import { SearchSelectField } from '@/components/ui/SearchSelectField/SearchSelectField';
import { api } from '@/api/client';

const PAGE_SIZE = 25;
const MIN_SEARCH_LENGTH = 2;

export type EditorValueItem = {
  id: string;
  name: string;
  edition_id?: string;
  edition_name?: string;
  department_id?: string | null;
  department_code?: string | null;
};

interface EditorComboProps {
  value: EditorValueItem | null;
  onChange: (v: EditorValueItem | null) => void;
  /** Ограничить список редакторами редакций этого подразделения */
  departmentId?: string | null;
  placeholder?: string;
  disabled?: boolean;
  containerRef?: React.RefObject<HTMLDivElement | null>;
  debounceFlushKey?: string | number;
}

export function EditorCombo({
  value,
  onChange,
  departmentId = null,
  placeholder = 'Редактор',
  disabled,
  containerRef,
  debounceFlushKey,
}: EditorComboProps) {
  return (
    <SearchSelectField<EditorValueItem>
      value={value}
      onChange={onChange}
      getOptionLabel={(ed) => ed.name}
      placeholder={placeholder}
      disabled={disabled}
      containerRef={containerRef}
      queryKey={['editors', 'search-field', departmentId ?? '']}
      fetchPage={(debouncedQuery, page) =>
        api.editors.list(debouncedQuery, {
          limit: PAGE_SIZE,
          offset: page * PAGE_SIZE,
          department_id: departmentId?.trim() ? departmentId.trim() : undefined,
        })
      }
      minSearchLength={MIN_SEARCH_LENGTH}
      debounceFlushKey={debounceFlushKey}
    />
  );
}
